<template>
  <div class="team-member">
    <div class="team-member__image">
      <picture>
        <source
          :srcset="webpSrc"
          type="image/webp"
        />
        <img
          :src="jpgSrc"
          :alt="name"
          width="200"
          height="200"
          class="team-member__img"
        />
      </picture>
    </div>
    <div class="team-member__content">
    <div class="team-member__header">
        <h3 class="team-member__name">{{ name }}</h3>
        <p class="team-member__role">{{ role }}</p>
      </div>
    
      
      <p v-for="(item, index) in bio"
        :key="index" 
      class="team-member__bio">
        {{ item }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeamMember',
  props: {
    name: {
      type: String,
      required: true
    },
    role: {
      type: String,
      required: true
    },
    bio: {
      type: Array,
      required: true,
      validator: (value) => value.every(item => typeof item === 'string')
    },
    image: {
      type: String,
      required: true,
      description: 'Image name without extension (e.g., "woj" for "woj.webp" and "woj.jpg")'
    }
  },
  computed: {
    webpSrc() {
      return `/assets/images/team/${this.image}.webp`;
    },
    jpgSrc() {
      return `/assets/images/team/${this.image}.jpg`;
    }
  }
}
</script>

<style lang="scss">
@use '@/assets/scss/main.scss';
@use '@/assets/scss/abstracts/variables' as *;
@use '@/assets/scss/abstracts/mixins' as *;

.team-member {
  &__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
}

.team-member {
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-template-rows: auto;
  grid-template-areas:
    "image text";
  gap: $spacing-lg;
  align-items: start;
  padding: $spacing-md;
  background: $color-background;
  border-radius: $border-radius;
  box-shadow: $shadow-sm;
  transition: transform $transition-base, box-shadow $transition-base;
  width: 100%;
  margin-bottom: $spacing-lg;

  // Large screens
  @include media-up(xl) {
    grid-template-columns: 1fr 4fr;
    gap: $spacing-xl;
    padding: $spacing-lg;
  }

  // Medium screens
  @include media-down(lg) {
    grid-template-columns: 1fr 3fr;
    gap: $spacing-lg;
  }

  // Small screens
  @include media-down(md) {
    grid-template-columns: 1fr 2fr;
    gap: $spacing-md;
  }

  @include media-down(sm) {
    display: block;
  }
  

  &__image {
    width: 200px;
    height: 200px;
    margin: 0 auto;
    border-radius: 50%;
    overflow: hidden;
    border: 4px solid $color-primary;
    grid-area: image;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: $spacing-md;
    grid-area: text;
  }

  &__header {
    display: flex;
    flex-direction: column;
    gap: $spacing-xs;
    grid-area: header;
  }

  &__name {
    color: $color-primary;
    font-size: 1.5rem;
    @include proxima-bold;
    margin-bottom: 0px;
  }

  &__role {
    color: $color-accent;
    font-size: 1.1rem;
    @include proxima-regular;
    margin-top: 0px;
  }

  &__bio {
    color: $color-text;
    line-height: 1.6;
    text-align: left;
    @include proxima-regular;
  }

  &__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  @include media-down(md) {
    grid-template-columns: 1fr;
    //text-align: center;

    &__header {
    //  align-items: center;
    }
  }
} 

</style> 